<!-- Instagram Stories (desktop) -->
<div class="igds-window">
  <a class="mst igds-story" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <div class="mst-screen igds-screen">
      <app-meta-creative class="mst-creative" [src]="data.creative" [kind]="data.creativeKind" slot="story"></app-meta-creative>
      <div class="mst-scrim"></div>
      <div class="mst-progress"></div>

      <div class="mst-header">
        <img class="mst-avatar" [src]="avatar" alt="" />
        <div class="mst-identity">
          <div class="mst-name">{{ accountName }}<i class="bi bi-patch-check-fill mst-verified"></i></div>
        </div>
        <div class="mst-header-icons igds-controls">
          <i class="bi bi-pause-fill"></i>
          <i class="bi bi-volume-up-fill"></i>
          <i class="bi bi-three-dots"></i>
        </div>
      </div>

      <span class="igds-label">Oglas</span>
    </div>
  </a>
</div>
